import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileSubNavBar from "./ProfileSubNavBar";
import EditProfile from "./EditProfile";
import ChangePassword from "./ChangePassword";
import SellerDocuments from "./SellerDocuments";

export default function Profile() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("edit"); // default is Edit Profile

  // Sync activeTab with URL
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/profile/changepassword')) {
      setActiveTab("password");
    } else if (path.includes('/profile/documents')) {
      setActiveTab("documents");
    } else {
      setActiveTab("edit");
    }
  }, [location.pathname]);

  // Handle tab change and update URL
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "password") {
      navigate("/profile/changepassword");
    } else if (tab === "documents") {
      navigate("/profile/documents");
    } else {
      navigate("/profile");
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Sub Navbar */}
      <ProfileSubNavBar activeTab={activeTab} setActiveTab={handleTabChange} />

      {/* Render Content */}
      <div className="pt-6">
        {activeTab === "edit" && <EditProfile />}
        {activeTab === "documents" && <SellerDocuments />}
        {activeTab === "password" && <ChangePassword />}
      </div>
    </div>
  );
}
